module.exports = __webpack_public_path__ + "static/img/007.346a872.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/factory/007.jpg
// module id = ygHr
// module chunks = 1